import React from "react";
import Flex from "../ui/Flex/Flex";
import Gradient from "../ui/Gradient/Gradient";
import "./index.scss";
import TedContact from "../../../assets/images/ted_contact.png";
import ContactForm from "./form";

const Contact = (): JSX.Element => {
  return (
    <section
      className="h-100 section-wrapper data-section"
      data-scroll-section
      id="me-contacter"
    >
      <Flex
        alignCenter
        minHeight="100vh"
        data-scroll
        data-scroll-repeat
        data-scroll-call="#me-contacter"
      >
        <Flex minHeight="70vh" justifyBetween alignCenter>
          <Flex column gap={12}>
            <Flex gap={8} column>
              <div className="font-weight-3" data-scroll>
                <Gradient>Un projet ?</Gradient>
                <h3 className="text-title-3 font-weight-3">
                  Je peux vous aider
                </h3>
              </div>
              <div className="relative contact_avatar_wrapper" data-scroll>
                <img src={TedContact} alt="" />
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
              </div>
            </Flex>
            <span>tedui.design@gmail.com</span>
          </Flex>
          <Flex selfStretch>
            <div className="contact-form" data-scroll>
              <ContactForm />
            </div>
          </Flex>
        </Flex>
      </Flex>
    </section>
  );
};

export default Contact;
